<template>
  <div class="main-layout__box">
    <div class="main-layout__list main-layout__list_mxh87" @scroll="scroll">
      <orders-list-head />
      <template v-if="orders && orders.length > 0">
        <div v-for="(item, index) in orders" :key="item.key">
          <orders-list-item :item="item" :index="item.id" :number="index + 1" />
        </div>
      </template>
      <div class="no-response" v-else>
        <svg
          width="233"
          height="260"
          viewBox="0 0 233 260"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="no-response__svg"
        >
          <path
            d="M20.7279 89.8754C21.4059 89.8754 21.8256 89.7138 22.0516 89.3905C22.2453 89.0672 22.3744 88.5499 22.3744 87.8387V86.4485C22.3744 84.6381 22.7619 82.957 23.5367 81.3728C24.3116 79.7887 25.2479 78.4308 26.3456 77.2347C27.4433 76.0385 28.5411 74.81 29.6388 73.5815C30.7365 72.3529 31.6728 70.8981 32.4477 69.217C33.2225 67.5359 33.61 65.6931 33.61 63.721C33.61 59.1949 32.0602 55.574 28.9285 52.8584C25.7968 50.1427 21.6964 48.7849 16.6275 48.7849C11.1389 48.7849 5.84403 50.563 0.710559 54.1515C-0.0320183 54.8305 -0.161162 55.5417 0.323127 56.2853L5.97317 65.1758C6.32832 65.6931 6.71575 65.9517 7.13547 65.9517C7.36147 65.9517 7.68433 65.7901 8.10405 65.4991C10.9129 63.5917 13.3667 62.6218 15.4975 62.6218C16.7567 62.6218 17.7575 62.9128 18.4356 63.527C19.1136 64.1413 19.4687 64.9819 19.4687 66.0164C19.4687 66.9216 19.0813 67.7622 18.3387 68.5704C17.5961 69.3786 16.6921 70.2515 15.6267 71.1244C14.5612 71.9973 13.5281 73.0319 12.4627 74.1957C11.3972 75.3596 10.5255 77.0084 9.75063 79.1098C9.00805 81.2112 8.62062 83.6682 8.62062 86.4162V87.8063C8.62062 88.4853 8.71748 88.9702 8.91119 89.3258C9.10491 89.6814 9.49234 89.8431 10.0735 89.8431H20.7279V89.8754ZM15.4007 110.243C17.5961 110.243 19.4687 109.499 20.9539 108.012C22.4713 106.525 23.2139 104.715 23.2139 102.549C23.2139 100.35 22.4713 98.475 20.9539 96.9879C19.4364 95.4684 17.5961 94.7248 15.4007 94.7248C13.2698 94.7248 11.4295 95.4684 9.94435 96.9879C8.45919 98.5073 7.7489 100.35 7.7489 102.581C7.7489 104.715 8.49148 106.557 9.97663 108.044C11.4618 109.532 13.2698 110.243 15.4007 110.243Z"
            fill="#502D8C"
          />
          <path
            d="M103.347 20.6908C103.67 20.6908 103.896 20.6261 103.993 20.4644C104.09 20.3028 104.155 20.0442 104.155 19.6885V19.0096C104.155 18.1044 104.348 17.2638 104.736 16.4556C105.123 15.6474 105.575 14.9685 106.124 14.3542C106.673 13.74 107.222 13.1257 107.771 12.5114C108.319 11.8972 108.771 11.1536 109.159 10.313C109.546 9.47249 109.74 8.53494 109.74 7.56506C109.74 5.26968 108.965 3.45924 107.383 2.1014C105.801 0.743574 103.799 0 101.281 0C98.5368 0 95.8893 0.90522 93.3065 2.71566C92.919 3.03895 92.8544 3.39458 93.1127 3.78253L95.9539 8.24397C96.1476 8.50261 96.3413 8.63192 96.5351 8.63192C96.6319 8.63192 96.7933 8.56727 97.0193 8.40562C98.4076 7.43574 99.6345 6.9508 100.732 6.9508C101.378 6.9508 101.862 7.11245 102.217 7.40341C102.573 7.7267 102.734 8.14698 102.734 8.66425C102.734 9.11686 102.54 9.53714 102.185 9.95743C101.798 10.3777 101.346 10.798 100.829 11.2506C100.313 11.7032 99.7636 12.2205 99.2471 12.8024C98.7305 13.3843 98.2785 14.2249 97.8911 15.2918C97.5036 16.3586 97.3422 17.5871 97.3422 18.9773V19.6562C97.3422 19.9795 97.4068 20.2381 97.5036 20.4321C97.6005 20.5938 97.7942 20.6908 98.0848 20.6908H103.347ZM100.7 30.7128C101.798 30.7128 102.734 30.3572 103.477 29.6136C104.219 28.8701 104.607 27.9648 104.607 26.898C104.607 25.7988 104.219 24.8612 103.477 24.1177C102.734 23.3741 101.798 22.9861 100.7 22.9861C99.6345 22.9861 98.7305 23.3741 97.9879 24.1177C97.2453 24.8612 96.8902 25.7988 96.8902 26.898C96.8902 27.9648 97.2453 28.8701 97.9879 29.6136C98.7305 30.3572 99.6345 30.7128 100.7 30.7128Z"
            fill="#502D8C"
          />
          <path
            d="M207.664 72.0944C208.148 72.0944 208.503 71.9651 208.632 71.7388C208.762 71.5124 208.858 71.0922 208.858 70.5426V69.508C208.858 68.1502 209.149 66.857 209.73 65.6932C210.311 64.497 211.022 63.4625 211.829 62.5572C212.636 61.652 213.475 60.7468 214.282 59.8092C215.09 58.8717 215.8 57.7725 216.381 56.5117C216.962 55.2508 217.253 53.8607 217.253 52.3735C217.253 48.9466 216.09 46.1986 213.734 44.1619C211.377 42.1251 208.31 41.0906 204.5 41.0906C200.399 41.0906 196.396 42.4484 192.554 45.1641C192.005 45.6813 191.908 46.1986 192.263 46.7805L196.493 53.505C196.751 53.893 197.042 54.1193 197.365 54.1193C197.526 54.1193 197.784 53.99 198.075 53.7637C200.173 52.3088 202.014 51.5976 203.628 51.5976C204.597 51.5976 205.307 51.8239 205.856 52.2765C206.405 52.7291 206.631 53.3757 206.631 54.1516C206.631 54.8305 206.34 55.4771 205.791 56.0914C205.242 56.7056 204.564 57.3522 203.757 57.9988C202.982 58.6454 202.175 59.4213 201.4 60.3265C200.625 61.1994 199.947 62.4602 199.366 64.0444C198.817 65.6285 198.527 67.4713 198.527 69.5727V70.6072C198.527 71.1245 198.591 71.4801 198.753 71.7711C198.914 72.062 199.205 72.159 199.625 72.159H207.664V72.0944ZM203.66 87.2891C205.307 87.2891 206.695 86.7395 207.825 85.608C208.955 84.5088 209.536 83.1187 209.536 81.5345C209.536 79.8857 208.955 78.4956 207.825 77.3641C206.695 76.2325 205.307 75.6506 203.66 75.6506C202.046 75.6506 200.69 76.2325 199.592 77.3641C198.495 78.4956 197.913 79.8857 197.913 81.5345C197.913 83.151 198.462 84.5088 199.592 85.608C200.69 86.7395 202.046 87.2891 203.66 87.2891Z"
            fill="#502D8C"
          />
          <path
            d="M166.079 41.6725C160.429 41.9311 150.873 55.6387 142.769 72.159C142.769 71.8357 83.0399 72.7086 83.0399 72.7086C78.7136 65.5315 66.2189 39.1185 58.0829 41.2845C47.9128 44.0002 50.6575 197.443 52.4009 260C60.7953 260 164.659 260 173.215 260C172.666 221.819 173.15 129.576 173.215 108.659C173.215 99.6389 172.763 41.3492 166.079 41.6725Z"
            fill="#F37928"
          />
          <path
            d="M69.2859 127.83H48.5583C48.1708 127.83 47.8802 127.507 47.8802 127.151C47.8802 126.763 48.2031 126.472 48.5583 126.472H69.2859C69.6733 126.472 69.9639 126.796 69.9639 127.151C69.9639 127.507 69.6733 127.83 69.2859 127.83Z"
            fill="#323031"
          />
          <path
            d="M48.978 138.046C48.6874 138.046 48.3968 137.852 48.3 137.529C48.2031 137.173 48.3968 136.785 48.7842 136.688L68.7047 130.998C69.0598 130.901 69.4473 131.095 69.5441 131.483C69.641 131.839 69.4473 132.227 69.0598 132.324L49.1394 138.014C49.1071 138.046 49.0425 138.046 48.978 138.046Z"
            fill="#323031"
          />
          <path
            d="M156.329 104.715C156.071 104.715 155.812 104.553 155.716 104.327C155.554 103.971 155.716 103.583 156.071 103.421L174.893 94.7895C175.249 94.6279 175.636 94.7895 175.797 95.1451C175.959 95.5008 175.797 95.8887 175.442 96.0504L156.62 104.682C156.523 104.682 156.458 104.715 156.329 104.715Z"
            fill="#323031"
          />
          <path
            d="M158.201 111.051C157.814 111.051 157.523 110.76 157.523 110.372C157.523 109.984 157.814 109.661 158.201 109.661L178.509 109.305C178.897 109.305 179.187 109.596 179.187 109.984C179.187 110.372 178.897 110.696 178.509 110.696L158.201 111.051Z"
            fill="#323031"
          />
          <path
            d="M103.154 119.683C102.863 119.78 102.734 120.136 102.896 120.394C103.8 121.914 106.77 126.149 111.355 125.341C116.004 124.533 116.746 119.845 116.875 118.39C116.908 118.164 116.714 117.937 116.488 117.937C114.841 117.84 108.901 117.776 103.154 119.683Z"
            fill="#323031"
          />
          <path
            d="M100.345 138.822C98.9242 138.822 97.4713 138.466 96.0508 137.755C95.6956 137.593 95.5665 137.173 95.7279 136.818C95.8893 136.462 96.309 136.333 96.6642 136.527C99.5376 137.981 102.702 137.658 105.285 135.654C108.868 132.841 110.45 127.701 109.32 122.528C109.223 122.14 109.482 121.784 109.837 121.687C110.224 121.623 110.579 121.849 110.644 122.205C111.903 127.83 116.229 133.811 123.139 134.49C128.434 135.007 133.083 132.001 135.536 126.44C135.698 126.084 136.085 125.923 136.441 126.084C136.796 126.246 136.957 126.634 136.796 126.989C134.084 133.132 128.918 136.462 123.01 135.88C117.941 135.363 113.485 132.065 110.999 127.183C110.676 131.031 108.933 134.49 106.124 136.688C104.348 138.111 102.347 138.822 100.345 138.822Z"
            fill="#323031"
          />
          <path
            d="M84.2988 115.448C83.9759 115.448 83.7176 115.222 83.6208 114.931C83.5239 114.575 83.7499 114.187 84.1373 114.09L95.3406 111.342L84.1373 106.396C83.7822 106.234 83.6208 105.846 83.7822 105.491C83.9436 105.135 84.331 104.973 84.6862 105.135L97.7297 110.89C97.988 111.019 98.1817 111.277 98.1494 111.568C98.1172 111.859 97.9234 112.118 97.6329 112.183L84.4602 115.416C84.3956 115.448 84.3311 115.448 84.2988 115.448Z"
            fill="#323031"
          />
          <path
            d="M128.757 108.271C128.789 109.629 127.723 110.76 126.367 110.793C125.011 110.825 123.881 109.758 123.849 108.4C123.817 107.042 124.882 105.911 126.238 105.878C127.594 105.846 128.724 106.913 128.757 108.271Z"
            fill="#323031"
          />
          <path
            d="M116.649 37.5667C116.681 38.0193 115.616 38.4072 114.26 38.4719C112.936 38.5366 111.838 38.2133 111.806 37.7607C111.774 37.308 112.839 36.9201 114.195 36.8554C115.519 36.7908 116.617 37.1141 116.649 37.5667Z"
            fill="#1D1818"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="83"
            y="37"
            width="64"
            height="39"
          >
            <path
              d="M83.7159 37.8253H146.415V75.9415H83.7159V37.8253Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)">
            <path
              d="M88.0424 75.9415C87.0092 75.8122 85.4595 75.5859 84.4909 75.4566C83.9743 75.3919 83.6515 74.907 83.7483 74.422C84.1035 72.4499 84.1035 70.9951 84.2326 69.1523C84.394 67.0186 85.2012 62.0399 86.8801 58.6453C87.8486 56.7056 88.7527 55.2184 89.3338 54.2485C89.7858 53.5696 90.0441 52.7937 90.1732 51.9855C90.6252 49.2375 92.627 44.2911 98.3093 41.9634C104.379 39.5064 110.933 38.8275 113.677 37.9546C114.065 37.8253 114.485 37.8253 114.84 37.9223C115.744 38.2132 116.68 38.1162 118.23 38.2132C120.102 38.3102 129.562 39.8943 133.727 42.2867C137.924 44.6791 138.312 47.0068 139.474 48.7849C140.636 50.563 141.476 52.2765 142.315 55.9297C143.187 59.5829 145.415 64.4969 145.737 68.1178C145.931 70.4455 146.189 72.5469 146.319 73.7431C146.383 74.3574 145.996 74.9716 145.415 75.1656C144.059 75.6182 142.444 75.9415 142.444 75.9415C135.115 72.1913 123.686 70.8011 115.033 70.8011C106.381 70.8011 94.1121 72.3206 88.0424 75.9415Z"
              fill="#1D1818"
            />
          </g>
          <path
            d="M91.6275 58.5807C90.7235 50.1427 94.8561 44.0325 99.5376 41.3815C99.1178 41.5431 98.6658 41.7048 98.2461 41.8988C92.5961 44.2265 90.5943 49.1729 90.1423 51.9532C90.0132 52.7614 89.7226 53.5373 89.3029 54.2162C88.6895 55.1538 87.7854 56.6733 86.8492 58.613C85.1703 62.0399 84.3631 67.0186 84.2017 69.1524C84.0726 71.0275 84.1048 72.45 83.7174 74.4544C83.6205 74.9716 83.9757 75.4243 84.46 75.5212C85.4286 75.6506 86.946 75.8769 87.9792 76.0062C88.3989 75.7475 88.8832 75.4889 89.3675 75.2626C90.2392 73.0319 92.4346 66.3074 91.6275 58.5807Z"
            fill="#9BCD82"
          />
          <path
            d="M146.675 73.7754C146.514 72.5792 146.288 70.4778 146.094 68.1178C145.771 64.4969 143.511 59.5829 142.64 55.8973C141.768 52.2441 140.928 50.4983 139.766 48.7202C138.572 46.9421 138.184 44.6144 133.955 42.222C133.438 41.9311 132.825 41.6401 132.147 41.3492C136.279 44.0648 139.895 49.4638 139.96 56.7702C140.024 64.1413 139.637 71.6417 140.767 75.0363C141.445 75.3272 142.123 75.6182 142.736 75.9415C142.736 75.9415 144.383 75.6182 145.739 75.1656C146.352 75.0039 146.74 74.422 146.675 73.7754Z"
            fill="#9BCD82"
          />
          <path
            d="M124.075 71.4477C124.042 68.3441 124.01 65.3375 124.01 63.3007C124.01 62.0399 123.946 54.0222 123.042 54.0546C122.267 54.0869 120.943 55.9943 119.845 58.2574C119.845 58.225 111.645 58.322 111.645 58.322C111.063 57.3198 109.352 53.6989 108.222 53.9899C107.028 54.3132 107.254 63.915 107.48 71.4154H124.075V71.4477Z"
            fill="#F07300"
          />
          <path
            d="M109.772 65.5315H107.06C106.996 65.5315 106.964 65.5639 106.964 65.6285C106.964 65.6608 106.996 65.7255 107.06 65.7255H109.772C109.837 65.7255 109.869 65.6932 109.869 65.6285C109.869 65.5962 109.837 65.5315 109.772 65.5315Z"
            fill="#111111"
          />
          <path
            d="M109.74 66.2751L107.028 67.051C106.964 67.051 106.964 67.1156 106.964 67.1803C106.964 67.2126 107.028 67.2449 107.06 67.2449H107.093L109.805 66.469C109.869 66.469 109.869 66.4044 109.869 66.3397C109.837 66.3074 109.805 66.2751 109.74 66.2751Z"
            fill="#111111"
          />
          <path
            d="M124.398 61.4903C124.366 61.458 124.301 61.4256 124.269 61.458L121.557 62.5572C121.492 62.5895 121.492 62.6218 121.492 62.6865C121.524 62.7188 121.557 62.7511 121.589 62.7511H121.621L124.333 61.6519C124.398 61.5873 124.398 61.5226 124.398 61.4903Z"
            fill="#111111"
          />
          <path
            d="M124.624 63.2685L121.912 63.3008C121.847 63.3008 121.815 63.3332 121.815 63.3978C121.815 63.4301 121.847 63.4948 121.912 63.4948L124.624 63.4625C124.688 63.4625 124.721 63.4301 124.721 63.3655C124.721 63.3008 124.688 63.2685 124.624 63.2685Z"
            fill="#111111"
          />
          <path
            d="M118.845 65.4668C118.812 65.4345 118.748 65.4668 118.715 65.5315C118.392 66.3074 117.779 66.7277 117.069 66.663C116.326 66.5983 115.777 66.0164 115.519 65.3698C116.1 65.2405 116.197 64.6263 116.229 64.4C116.229 64.3676 116.197 64.3353 116.165 64.3353C115.939 64.3353 115.164 64.3353 114.389 64.5939C114.357 64.5939 114.324 64.6586 114.357 64.6909C114.454 64.8849 114.776 65.3375 115.261 65.4022C115.293 65.9841 115.067 66.5014 114.68 66.8247C114.324 67.1156 113.905 67.1479 113.517 66.954C113.485 66.9216 113.42 66.954 113.388 66.9863C113.356 67.0186 113.388 67.0833 113.42 67.1156C113.614 67.2126 113.808 67.2773 114.002 67.2773C114.26 67.2773 114.55 67.1803 114.776 66.9863C115.164 66.6953 115.39 66.2104 115.422 65.6608C115.745 66.3397 116.358 66.7923 117.036 66.857C117.811 66.954 118.522 66.469 118.877 65.6285C118.909 65.5638 118.909 65.4992 118.845 65.4668Z"
            fill="#111111"
          />
          <path
            d="M117.618 63.3331C117.78 63.3331 117.909 63.2038 117.909 63.0098C117.909 62.8482 117.78 62.7188 117.586 62.7188C117.424 62.7188 117.295 62.8482 117.295 63.0421C117.327 63.2038 117.457 63.3654 117.618 63.3331Z"
            fill="#111111"
          />
          <path
            d="M113.743 63.5271C113.743 63.4948 113.711 63.4625 113.679 63.4301L111.935 62.7189C111.903 62.6866 111.838 62.7189 111.806 62.7512C111.774 62.7836 111.806 62.8482 111.838 62.8805L113.324 63.4948L111.838 63.8504C111.774 63.8504 111.774 63.9151 111.774 63.9474C111.774 63.9797 111.806 64.0121 111.871 64.0121C111.871 64.0121 111.871 64.0121 111.903 64.0121L113.646 63.6241C113.711 63.5918 113.743 63.5595 113.743 63.5271Z"
            fill="#111111"
          />
          <mask
            id="mask1"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="87"
            y="70"
            width="58"
            height="17"
          >
            <path
              d="M87.5581 70.7042H144.414V86.9658H87.5581V70.7042Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1)">
            <path
              d="M142.703 75.8446C135.341 72.062 123.944 70.6719 115.324 70.6719C106.704 70.6719 94.435 72.1914 88.3975 75.8446C88.3975 75.8446 88.3975 75.8446 88.3653 75.8446C87.7518 79.2715 86.7187 85.414 88.7527 86.6102C90.9804 87.9357 102.959 80.5 115.873 80.5C131.08 80.5 141.056 88.2913 143.445 86.7395C145.641 85.317 143.51 78.0753 142.767 75.8122C142.735 75.8446 142.703 75.8446 142.703 75.8446Z"
              fill="#292121"
            />
          </g>
          <path
            d="M43.2314 200.927C41.1329 200.474 39.4863 200.054 37.7428 199.213C32.2542 196.562 32.6739 190.614 37.8074 188.641C44.6197 185.99 52.1424 184.568 59.439 184.212L58.5027 162.261C42.9086 163.037 22.859 170.375 13.3669 180.947C8.91145 185.926 7.10343 191.971 8.29801 197.985C9.75088 205.42 15.6915 211.983 25.0222 216.477C30.1233 218.934 36.4837 220.712 43.296 222.005L43.2314 200.927Z"
            fill="#F37928"
          />
          <path
            d="M76.1307 207.166L67.4781 206.196L72.8698 204.58C74.8393 203.998 75.9693 201.897 75.3559 199.924C74.7747 197.952 72.6761 196.821 70.7067 197.435C68.8987 197.985 67.1229 198.534 65.3149 199.052C63.0872 199.73 60.6012 200.506 58.3734 200.894C58.8577 199.569 59.6003 198.276 60.2137 197.015C61.1178 195.172 60.5043 192.877 58.7286 191.907C56.856 190.905 54.5637 191.648 53.6274 193.523L49.4302 201.573C46.6536 201.573 46.6536 201.573 41.6816 200.474L37.2584 220.938C40.5839 221.488 48.4294 223.234 50.528 223.719C55.5 224.818 56.4686 224.786 60.02 227.372L63.4746 229.861C65.1212 231.058 67.5104 230.831 68.7372 229.182C70.0287 227.501 69.6735 225.109 67.9624 223.88L63.7329 220.809L72.2564 223.46C74.2259 224.074 76.3244 222.975 76.9379 221.003C77.5513 219.031 76.4536 216.93 74.4841 216.315L65.2181 213.438L75.4527 214.602C77.5513 214.828 79.4239 213.309 79.5853 211.207C79.7468 209.171 78.1647 207.392 76.1307 207.166Z"
            fill="#333132"
          />
          <path
            d="M220.32 163.425L228.908 158.123C230.845 156.926 231.426 154.405 230.264 152.465C229.263 150.848 227.939 150.073 224.614 151.721L230.296 147.777C232.233 146.581 232.814 144.059 231.652 142.12C230.457 140.18 227.939 139.566 226.002 140.762L220.546 144.124L225.453 138.79C227.003 137.109 226.874 134.522 225.195 132.97C223.548 131.419 220.933 131.548 219.383 133.229L213.83 139.275C210.698 137.981 207.244 137.723 203.918 138.596C201.723 139.178 200.399 141.408 200.98 143.607C201.561 145.805 203.789 147.131 205.985 146.549C207.889 146.064 209.859 146.322 211.57 147.292C215.154 149.329 215.089 152.206 213.055 155.795C211.021 159.383 206.437 160.677 202.853 158.64C199.269 156.603 199.334 153.726 201.368 150.137C202.498 148.165 201.787 145.643 199.818 144.512C197.849 143.38 195.33 144.092 194.232 146.064C190.294 153.047 192.263 161.776 198.559 166.431C198.688 168.112 198.527 170.02 197.816 171.927C193.684 182.854 179.123 190.129 166.628 182.79C155.231 176.098 147.87 158.834 145.771 152.853L122.784 162.455C123.042 163.231 127.304 175.386 136.247 186.734C145.739 198.793 160.687 208.395 176.346 208.071C189.712 207.813 202.53 200.991 210.601 190.355C213.217 186.928 215.315 183.113 216.833 179.104C219.674 171.572 220.384 166.625 220.32 163.425Z"
            fill="#F37928"
          />
          <path
            d="M138.9 123.275C154.457 121.707 165.673 107.701 163.981 92.0125C162.352 76.874 148.983 65.9148 134.003 67.455C118.479 69.0541 107.169 83.0974 108.824 98.6899C110.422 113.862 123.822 124.788 138.9 123.275ZM173.076 133.842C168.621 130.221 164.301 126.692 159.814 123.073C159.291 123.488 158.704 123.94 158.088 124.425C138.299 139.4 110.096 130.852 102.119 107.079C95.5776 87.6272 106.878 66.008 126.391 60.3783C145.653 54.8583 164.879 65.2081 170.928 84.4892C173.8 93.7144 172.96 102.762 168.747 111.388C168.228 112.454 168.229 113.039 169.238 113.803C172.842 116.62 176.357 119.571 179.935 122.486C180.34 122.824 180.776 123.128 181.18 123.434C181.369 123.359 181.467 123.387 181.527 123.319C183.306 121.184 183.287 120.275 186.527 122.914C196.456 131.114 206.475 139.212 216.435 147.377C219.609 149.987 220.836 153.472 220.063 157.444C219.32 161.382 216.896 164.068 213.068 165.262C209.714 166.303 206.499 165.809 203.732 163.569C193.271 155.07 182.841 146.537 172.41 138.004C171.161 136.992 171.127 136.375 172.054 135.127C172.387 134.753 172.716 134.315 173.076 133.842Z"
            fill="#F1ECFF"
          />
          <path
            opacity="0.3"
            d="M134.524 70.7643C133.125 71.0598 131.722 71.2904 130.36 71.6816C127.321 72.5768 124.607 74.1063 122.216 76.2053C121.541 76.7907 121.168 77.589 121.85 78.271C122.259 78.6737 123.093 78.6332 123.741 78.6993C124.032 78.7177 124.37 78.4412 124.684 78.296C134.168 74.1298 145.017 76.4636 152.055 84.2485C153.429 85.7746 154.438 87.676 155.721 89.3041C156.101 89.7732 157.029 90.2483 157.471 90.0968C157.913 89.9453 158.151 89.0236 158.339 88.3643C158.449 88.0339 158.23 87.5894 158.112 87.2051C155.168 76.6859 145.187 69.7915 134.524 70.7643ZM138.844 123.8C123.741 125.346 110.37 114.293 108.731 98.9645C107.065 83.1821 118.367 69.0457 133.886 67.4471C148.861 65.9074 162.233 76.993 163.869 92.2566C165.602 108.101 154.397 122.232 138.844 123.8Z"
            fill="#BEB4DC"
          />
          <path
            opacity="0.4968"
            d="M134.575 70.9399C145.164 70.0014 155.032 76.8579 158.009 87.3097C158.128 87.6952 158.346 88.141 158.236 88.4724C158.046 89.1011 157.81 90.0581 157.365 90.1776C156.89 90.3311 155.992 89.853 155.611 89.3825C154.325 87.7495 153.349 85.8733 151.972 84.3426C144.987 76.5636 134.214 74.2505 124.838 78.3905C124.524 78.5362 124.217 78.812 123.924 78.761C123.277 78.7272 122.439 78.7354 122.031 78.3639C121.35 77.7124 121.724 76.9117 122.4 76.3245C124.764 74.2208 127.451 72.6882 130.464 71.7919C131.8 71.4661 133.205 71.2347 134.575 70.9399Z"
            fill="white"
          />
          <path
            d="M220.319 163.425L228.907 158.123C230.844 156.926 231.426 154.405 230.263 152.465C229.262 150.848 227.939 150.073 224.613 151.721L230.296 147.777C232.233 146.581 232.814 144.059 231.652 142.12C230.457 140.18 227.939 139.565 226.002 140.762L220.545 144.124L225.453 138.79C227.002 137.108 226.873 134.522 225.194 132.97C223.516 131.419 220.933 131.548 219.383 133.197L213.83 139.242C210.795 137.981 207.437 137.723 204.209 138.466C202.078 138.984 200.56 140.988 200.883 143.154C201.271 145.611 203.66 147.131 205.984 146.516C208.632 145.837 212.28 147.098 213.701 149.523C215.218 152.109 212.764 156.991 210.472 158.413C207.728 160.095 203.66 159.965 201.4 157.476C199.462 155.342 200.044 152.4 201.367 150.073C202.562 147.971 201.69 145.255 199.43 144.286C197.428 143.413 195.136 144.35 194.103 146.258C190.326 153.208 192.36 161.808 198.558 166.399C198.688 168.08 198.526 169.987 197.816 171.895C197.332 173.156 196.783 174.222 196.137 175.16L196.654 175.386C203.079 178.134 210.117 179.201 217.058 178.555C219.706 171.345 220.384 166.56 220.319 163.425Z"
            fill="#333132"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ordersListItem from '@/components/lists/orders/ordersListItem'
import ordersListHead from '@/components/lists/orders/ordersListHead'

export default {
    name: 'orders-list',
    components: {
        ordersListItem,
        ordersListHead,
    },
    data() {
        return {
            isAllowed: true,
        }
    },
    computed: {
        ...mapGetters({
            orders: 'orders/ordersGetters',
        }),
    },
    methods: {
        ...mapActions({
            fetch: 'orders/fetch',
        }),
        async scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (
                scrollTop + clientHeight >= scrollHeight - 10
        && this.isAllowed === true
            ) {
                this.isAllowed = false
                await this.fetch({})

                setTimeout(() => {
                    // to delay fetching users
                    this.isAllowed = true
                }, 1000)
            }
        },
    },
}
</script>

<style lang="scss">
.w-100 {
  width: 100%;
  padding-right: 15px !important;
}

.down {
  transform: rotate(180deg);
}

.flexbox {
  display: flex;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 5px;

    img {
      cursor: pointer;
    }
  }
}

.orders {
  margin: 0 62px;
  width: calc(100% - 130px);
  border-radius: 8px;
  background-color: #ffffff;
  height: calc(100% - 86px);
  position: relative;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

  &__body {
    overflow-y: scroll;
    height: calc(100vh - 304px);
    width: 100%;
  }

  &-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 0;

    &_new {
      background-color: rgba(113, 189, 74, 0.15);
    }

    &_head {
      width: 100%;
      padding: 14px 0;
      font-family: "SFUIDisplay-Bold";
      font-size: 12px;
      color: #4d4d4d;

      div {
        height: 20px;
        display: flex;
        align-items: center;
      }
    }

    &__index {
      width: 64px;
      height: 100%;
      font-family: "SFUIDisplay-Light";
      font-size: 30px;
      color: #e0e0e0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__image {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      &_w50 {
        width: 50px;
      }
    }

    &___name {
      &_transform {
        width: 100%;
        white-space: pre;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__price {
      width: 5%;
      display: flex;
    }

    &__name {
      width: 9%;
      padding: 0 5px;
    }

    &__email {
      width: 9%;
    }

    &__phone {
      width: 9%;
    }

    &__paid {
      width: 5%;
    }

    &__spent {
      width: 4.5%;
    }

    &__rate {
      width: 5.5%;
    }

    &__company {
      width: 5%;
    }

    &__time {
      width: 8%;
    }

    &__time2 {
      width: 6%;
    }

    &__date-start {
      width: 9%;
    }

    &__status {
      width: 10%;
    }

    &__actions {
      width: 100px;
      display: flex;
      align-items: flex-end;

      svg {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        display: block;
        padding-bottom: 2px;
        cursor: pointer;

        transition: all 0.5s;

        &:hover {
          transform: scale(1.1);
        }
      }

      img {
        width: 28px;
        height: 28px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    &__payment {
      width: 6%;
    }

    &__details {
      &:hover {
        opacity: 0.9;
      }
    }

    &__pdf {
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
